/**
 * Cart upsell pop-up — doubles the quantity from the add action, or splits bundle
 * pick-and-mix lines into standalone flavor products when configured.
 */
(function () {
  'use strict';

  var pendingUpsell = null;
  var isProcessing = false;
  var cartSnapshot = null;

  function getConfig() {
    return window.nfCartUpsellPopup || null;
  }

  function isTestMode() {
    try {
      return new URLSearchParams(window.location.search).has('nf_upsell_test');
    } catch (error) {
      return false;
    }
  }

  function isActive() {
    var config = getConfig();
    if (!config || !config.products || config.products.length === 0) return false;
    return config.enabled || isTestMode();
  }

  function getProductConfig(productId) {
    var config = getConfig();
    if (!config) return null;
    var id = Number(productId);
    return config.products.find(function (entry) {
      return Number(entry.productId) === id;
    }) || null;
  }

  function setCartSnapshot(cart) {
    cartSnapshot = cart;
  }

  function getLineQuantity(cart, variantId, lineKey) {
    if (!cart || !cart.items) return 0;

    var line = cart.items.find(function (item) {
      if (lineKey && item.key === lineKey) return true;
      return item.variant_id === variantId;
    });

    return line ? line.quantity : 0;
  }

  function getAddedQuantity(cart, variantId, lineKey, previousCart) {
    var newQuantity = getLineQuantity(cart, variantId, lineKey);
    var previousQuantity = getLineQuantity(previousCart, variantId, lineKey);
    var addedQuantity = newQuantity - previousQuantity;

    return addedQuantity > 0 ? addedQuantity : 1;
  }

  function getPopup() {
    return document.getElementById('nf-cart-upsell-popup');
  }

  function setError(message) {
    var popup = getPopup();
    if (!popup) return;
    var errorEl = popup.querySelector('[data-upsell-error]');
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function setProcessing(processing) {
    isProcessing = processing;
    var popup = getPopup();
    if (!popup) return;
    var acceptBtn = popup.querySelector('[data-upsell-accept]');
    var declineBtn = popup.querySelector('[data-upsell-decline]');
    var config = getConfig();

    if (acceptBtn) {
      acceptBtn.disabled = processing;
      if (processing && config) {
        acceptBtn.dataset.originalLabel = acceptBtn.textContent;
        acceptBtn.textContent = config.strings.processing;
      } else if (acceptBtn.dataset.originalLabel) {
        acceptBtn.textContent = acceptBtn.dataset.originalLabel;
        delete acceptBtn.dataset.originalLabel;
      }
    }
    if (declineBtn) declineBtn.disabled = processing;
  }

  function showPopup(upsellData) {
    var popup = getPopup();
    if (!popup) return;

    pendingUpsell = upsellData;
    setError('');

    var preview = popup.querySelector('[data-upsell-product-preview]');
    var imageEl = popup.querySelector('[data-upsell-image]');
    var titleEl = popup.querySelector('[data-upsell-product-title]');
    var variantEl = popup.querySelector('[data-upsell-variant-title]');

    if (preview && imageEl && titleEl && variantEl) {
      if (upsellData.image) {
        imageEl.src = upsellData.image;
        imageEl.alt = upsellData.title || '';
        preview.hidden = false;
      } else {
        preview.hidden = true;
      }
      titleEl.textContent = upsellData.title || '';
      variantEl.textContent = upsellData.displayVariantTitle || upsellData.variantTitle || '';
    }

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('nf-upsell-popup-open');

    var acceptBtn = popup.querySelector('[data-upsell-accept]');
    if (acceptBtn) acceptBtn.focus();
  }

  function hidePopup() {
    var popup = getPopup();
    if (!popup) return;
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nf-upsell-popup-open');
    pendingUpsell = null;
    setProcessing(false);
    setError('');
  }

  function getDiscountCodes() {
    var config = getConfig();
    if (!config || !config.discountCode) return [];

    return String(config.discountCode)
      .split(/[\n,]+/)
      .map(function (code) {
        return code.trim();
      })
      .filter(Boolean);
  }

  function getOrderTag() {
    var config = getConfig();
    if (!config || !config.orderTag) return '';

    return String(config.orderTag).trim();
  }

  function applyUpsellAttributes(body) {
    var orderTag = getOrderTag();
    if (!orderTag) return body;

    body.attributes = body.attributes || {};
    body.attributes.upsell_popup = orderTag;
    return body;
  }

  function cartHasDiscountCode(cart, code) {
    if (!cart || !code) return false;

    var normalizedCode = code.toLowerCase();
    var discountCodes = cart.discount_codes || [];

    return discountCodes.some(function (entry) {
      return String(entry.code || '').toLowerCase() === normalizedCode && entry.applicable === true;
    });
  }

  function cartHasAllDiscountCodes(cart, codes) {
    return codes.every(function (code) {
      return cartHasDiscountCode(cart, code);
    });
  }

  function getCartDrawerSectionId() {
    return 'cart-drawer';
  }

  function assertDiscountsApplied(cart, codes) {
    if (!codes.length) return;

    if (!cartHasAllDiscountCodes(cart, codes)) {
      throw new Error('discount_not_applied');
    }
  }

  function postCartUpdate(body) {
    return fetch(Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (cart) {
        if (!response.ok) throw new Error(cart.description || 'update_failed');
        return cart;
      });
    });
  }

  function publishCartChange(cart) {
    setCartSnapshot(cart);
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'upsell:double',
        cart: cart
      }
    }));
  }

  function openCartDrawer() {
    if (window.themeVariables && window.themeVariables.settings.cartType !== 'drawer') {
      return;
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.show === 'function') {
      cartDrawer.show();
    }
  }

  function completeUpsell(cartUpdatePromise) {
    var config = getConfig();

    return cartUpdatePromise
      .then(function (cart) {
        assertDiscountsApplied(cart, getDiscountCodes());
        hidePopup();
        publishCartChange(cart);
        openCartDrawer();
      })
      .catch(function (error) {
        setProcessing(false);
        setError(config && config.strings.errorGeneric);
        console.error('[nf-cart-upsell-popup]', error);
      });
  }

  function buildCartUpdateBody(lineKey, quantity) {
    var sectionId = getCartDrawerSectionId();
    var codes = getDiscountCodes();
    var body = {
      updates: {},
      sections: sectionId
    };

    body.updates[lineKey] = quantity;

    if (codes.length) {
      body.discount = codes.join(',');
    }

    return applyUpsellAttributes(body);
  }

  function buildBundleFinalizeBody(bundleLineKey) {
    var sectionId = getCartDrawerSectionId();
    var codes = getDiscountCodes();
    var body = {
      updates: {},
      sections: sectionId
    };

    body.updates[bundleLineKey] = 0;

    if (codes.length) {
      body.discount = codes.join(',');
    }

    return applyUpsellAttributes(body);
  }

  function isBundleSplitProduct(productId) {
    var config = getConfig();
    var bundleSplit = config && config.bundleSplit;

    return Boolean(
      bundleSplit &&
      bundleSplit.productId &&
      Number(bundleSplit.productId) === Number(productId) &&
      bundleSplit.flavorVariants
    );
  }

  function parseBundleFlavors(variantTitle) {
    if (!variantTitle) return [];

    return variantTitle
      .split(/\s*\/\s*/)
      .map(function (flavor) {
        return flavor.trim();
      })
      .filter(Boolean);
  }

  function normalizeFlavorLabel(flavorName) {
    return String(flavorName || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/æ/g, 'ae')
      .replace(/ø/g, 'o')
      .replace(/œ/g, 'oe')
      .replace(/['']/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Map translated option labels back to the Dutch keys used in bundleSplit.flavorVariants.
  var FLAVOR_ALIASES = {
    wit: 'Wit',
    white: 'Wit',
    blanco: 'Wit',
    blanc: 'Wit',
    weiss: 'Wit',
    bianco: 'Wit',
    hvid: 'Wit',
    hvidvin: 'Wit',
    hvit: 'Wit',
    vit: 'Wit',
    valkoinen: 'Wit',

    rood: 'Rood',
    red: 'Rood',
    'rode wijn': 'Rood',
    rodvin: 'Rood',
    tinto: 'Rood',
    rot: 'Rood',
    rouge: 'Rood',
    rosso: 'Rood',
    rod: 'Rood',

    rose: 'Rosé',
    rosado: 'Rosé',
    rosa: 'Rosé',

    'oaked wit': 'Oaked Wit',
    'oaked white': 'Oaked Wit',
    'oaked weiss': 'Oaked Wit',
    'oaked blanc': 'Oaked Wit',
    'oaked bianco': 'Oaked Wit',
    'blanc boise': 'Oaked Wit',
    'blanco roble': 'Oaked Wit',
    'egetrae hvid': 'Oaked Wit',
    'egetra hvid': 'Oaked Wit',

    'oaked rood': 'Oaked Rood',
    'oaked red': 'Oaked Rood',
    'oaked rotwein': 'Oaked Rood',
    'oaked rot': 'Oaked Rood',
    'oaked rouge': 'Oaked Rood',
    'oaked rosso': 'Oaked Rood',
    'rouge boise': 'Oaked Rood',
    'egetrae rodvin': 'Oaked Rood',
    'egetra rodvin': 'Oaked Rood',

    'sparkling wit': 'Sparkling Wit',
    'sparkling white': 'Sparkling Wit',
    'sparkling weiss': 'Sparkling Wit',
    'sparkling blanc': 'Sparkling Wit',
    'blanc petillant': 'Sparkling Wit',
    'blanco espumoso': 'Sparkling Wit',
    'schaumwein weiss': 'Sparkling Wit',
    'mousserende hvidvin': 'Sparkling Wit',
    'mousserende hvid': 'Sparkling Wit',

    'sparkling rose': 'Sparkling Rosé',
    'rosado espumoso': 'Sparkling Rosé',
    'mousserende rose': 'Sparkling Rosé',
    'schaumwein rose': 'Sparkling Rosé',
    'rose petillant': 'Sparkling Rosé',

    'orange spritz': 'Orange Spritz'
  };

  function getFlavorVariantId(flavorName, bundleSplit) {
    if (!bundleSplit || !bundleSplit.flavorVariants) return null;

    var variants = bundleSplit.flavorVariants;
    var exact = String(flavorName || '').trim();

    if (variants[exact]) return Number(variants[exact]);

    var normalized = normalizeFlavorLabel(exact);
    var canonical = FLAVOR_ALIASES[normalized];

    if (canonical && variants[canonical]) {
      return Number(variants[canonical]);
    }

    // Case-insensitive fallback against configured keys
    var matchKey = Object.keys(variants).find(function (key) {
      return normalizeFlavorLabel(key) === normalized;
    });

    return matchKey && variants[matchKey] ? Number(variants[matchKey]) : null;
  }

  function buildBundleFlavorItems(pending, bundleSplit) {
    var addedQuantity = pending.addedQuantity || 1;
    var totalBundleUnits = pending.quantity + addedQuantity;
    var bottlesPerFlavor = Number(bundleSplit.bottlesPerFlavor) || 3;
    var flavors = parseBundleFlavors(pending.variantTitleForSplit || pending.variantTitle);
    var flavorQuantities = {};
    var items = [];

    flavors.forEach(function (flavor) {
      var variantId = getFlavorVariantId(flavor, bundleSplit);

      if (!variantId) {
        throw new Error('missing_flavor_variant:' + flavor);
      }

      flavorQuantities[variantId] = (flavorQuantities[variantId] || 0) + (bottlesPerFlavor * totalBundleUnits);
    });

    Object.keys(flavorQuantities).forEach(function (variantId) {
      items.push({
        id: Number(variantId),
        quantity: flavorQuantities[variantId]
      });
    });

    return items;
  }

  function splitBundleOrder() {
    if (!pendingUpsell || isProcessing) return;

    var config = getConfig();
    var bundleSplit = config && config.bundleSplit;
    var items;

    setProcessing(true);
    setError('');

    try {
      items = buildBundleFlavorItems(pendingUpsell, bundleSplit);
    } catch (error) {
      setProcessing(false);
      setError(config && config.strings.errorGeneric);
      console.error('[nf-cart-upsell-popup]', error);
      return;
    }

    var bundleLineKey = pendingUpsell.lineKey;

    completeUpsell(
      addCartItems(items).then(function () {
        return postCartUpdate(buildBundleFinalizeBody(bundleLineKey));
      })
    );
  }

  function declineUpsell() {
    if (isProcessing) return;
    hidePopup();
    openCartDrawer();
  }

  function doubleOrder() {
    if (!pendingUpsell || isProcessing) return;

    if (isBundleSplitProduct(pendingUpsell.productId)) {
      splitBundleOrder();
      return;
    }

    var addedQuantity = pendingUpsell.addedQuantity || 1;
    var newQuantity = pendingUpsell.quantity + addedQuantity;

    setProcessing(true);
    setError('');

    completeUpsell(
      postCartUpdate(buildCartUpdateBody(pendingUpsell.lineKey, newQuantity))
    );
  }

  function addCartItems(items) {
    return fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) throw new Error(body.description || 'add_failed');
        return body;
      });
    });
  }

  function maybeQueueFromAddedItems(items, cart, previousCart) {
    if (!isActive() || !items || !items.length) return;

    var addedItem = items.find(function (item) {
      return getProductConfig(item.product_id);
    });

    if (!addedItem) return;

    var productConfig = getProductConfig(addedItem.product_id);
    var cartLine = (cart && cart.items ? cart.items : []).find(function (line) {
      return line.variant_id === addedItem.variant_id || line.key === addedItem.key;
    }) || addedItem;

    var addedQuantity = getAddedQuantity(
      cart,
      addedItem.variant_id,
      cartLine.key,
      previousCart
    );

    queueUpsell({
      lineKey: cartLine.key,
      quantity: cartLine.quantity || addedItem.quantity || 1,
      addedQuantity: addedQuantity,
      productId: addedItem.product_id,
      title: (productConfig && productConfig.title) || addedItem.product_title || addedItem.title,
      // Translated title for modal display
      displayVariantTitle: addedItem.variant_title || cartLine.variant_title || '',
      // Untranslated title for flavor → product mapping across locales
      variantTitleForSplit:
        addedItem.untranslated_variant_title ||
        cartLine.untranslated_variant_title ||
        addedItem.variant_title ||
        cartLine.variant_title ||
        '',
      variantTitle: addedItem.variant_title || cartLine.variant_title || '',
      image: (productConfig && productConfig.image) || addedItem.image || cartLine.image
    });
  }

  function queueUpsell(data) {
    if (!data || !data.lineKey) return;

    setTimeout(function () {
      showPopup(data);
    }, 150);
  }

  function onVariantAdded(event) {
    if (!isActive()) return;

    var detail = event.detail || {};
    var previousCart = cartSnapshot;
    var cart = detail.cart;

    maybeQueueFromAddedItems(detail.items, cart, previousCart);

    if (cart) {
      setCartSnapshot(cart);
    }
  }

  function onCartChange(event) {
    var detail = event.detail || {};
    if (!detail.cart || detail.baseEvent === 'variant:add' || detail.baseEvent === 'upsell:double') {
      return;
    }

    setCartSnapshot(detail.cart);
  }

  function bindPopupEvents() {
    var popup = getPopup();
    if (!popup || popup.dataset.bound === 'true') return;
    popup.dataset.bound = 'true';

    popup.querySelectorAll('[data-upsell-close]').forEach(function (button) {
      button.addEventListener('click', hidePopup);
    });

    var acceptBtn = popup.querySelector('[data-upsell-accept]');
    if (acceptBtn) {
      acceptBtn.addEventListener('click', doubleOrder);
    }

    var declineBtn = popup.querySelector('[data-upsell-decline]');
    if (declineBtn) {
      declineBtn.addEventListener('click', declineUpsell);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup && !popup.hidden) {
        hidePopup();
      }
    });
  }

  function init() {
    if (!getConfig()) return;

    bindPopupEvents();
    document.documentElement.addEventListener('variant:add', onVariantAdded);
    document.documentElement.addEventListener('cart:change', onCartChange);

    fetch(Shopify.routes.root + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(setCartSnapshot)
      .catch(function () {
        /* ignore */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
